// extracted by mini-css-extract-plugin
module.exports = {"defaultInput":"NumberField_defaultInput__NPU8a"};